import { atom } from 'recoil'

export const previewState = atom({
  key: 'CampaignWizard__PreviewState',
  default: {
    active: false,
    html: false,
    hasPersonalization: false,
    showPersonalization: false,
    dynamicContents: [],
    selectedDynamicContents: [],
    loading: false,
    autoSave: false,
    IdRecipient: undefined,
    recipient: undefined,
    callPreview: false,
    error: false,
    previewOnLoad: false
  }
})

export const groupsState = atom({
  key: 'CampaignWizard__GroupsState',
  default: []
})

export const filtersState = atom({
  key: 'CampaignWizard__FiltersState',
  default: {
    options: [],
    optionGroups: []
  }
})

export const previewLastSelected = atom({
  key: 'CampaignWizard__LastSelected',
  default: {
    lastEmails: [],
    lastFilters: [],
    lastGroups: [],
    previewReferenceRecipient: {
      lastEmails: [],
      lastFilters: [],
      lastGroups: [],
      lastTypeSelected: null
    }
  }
})
